var map = {
	"./001-neptune.svg": "b753",
	"./002-venus.svg": "d1cb",
	"./003-mercury.svg": "b71f",
	"./004-uranus.svg": "3e63",
	"./005-mars.svg": "7425",
	"./006-saturn.svg": "11f9",
	"./007-jupiter.svg": "de6d",
	"./008-planet-earth.svg": "b670",
	"./009-sun.svg": "fe89"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4bd5";